import React from "react";
import Element from '../../basic/element';
import SectionFrame from '../../basic/sectionFrame';
import './index.scss';
import ConfigParser from "../../../js/common/utility/configParser";

const DefaultProps = {
  icon: null,
  title: null,
  description: null,
  actions: [],
  content: null,
  columns: 3,
  cards: []
};

export default class SectionFrameWidget extends React.Component {
    render() {
        const data = ConfigParser.parse(this.props.config, DefaultProps);
        
        const header = {
            icon: data.icon,
            title: data.title,
            description: data.description,
        }
        const footer = {
            actions: data.actions
        }

        const cards = Array.from(this.props.config.querySelectorAll("sectionframe > cards > card"))
            .map(i => {
              return i.children.length > 0 ? i.children[0] : null;
            })
            .filter(i => !!i);

        const contentNode = this.props.config.querySelector("sectionframe > content");
        const content = contentNode && contentNode.children.length > 0 ? contentNode.children[0] : null

        const body = this.renderBody(cards, content);

        return (
            <SectionFrame id={data.id}
                className='pubhub-widget'
                style={data.style}
                columns={data.columns}
                header={header}
                footer={footer}>
                {body}
            </SectionFrame>
        );
    }

    renderBody(cards, content) {
        if(cards && cards.length != 0) {
            return cards.map((i, index) => <SectionFrameDomHost key={index}  className='pubhub-section-frame-card-item' card={i}/>);
        }

        return <SectionFrameDomHost className='content' card={content}/>;
    }
}

class SectionFrameDomHost extends React.Component {
  constructor(props) {
    super(props);

    this.rootDOM = null;
  }

  componentDidMount() {
    this.rootDOM.appendChild(this.props.card);
  }

  render() {
    return (
      <div ref={dom => this.rootDOM = dom} className={this.props.className}></div>
    );
  }
}